import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { UtilitariosService } from '../services/utilitarios.service';

@Pipe({
name: 'fechapipe'
})
export class FechaPipe implements PipeTransform
{
  constructor(public utilitariosService: UtilitariosService) {}
  transform(value:Date, incluirHora: boolean = false, formatoEspecifico: string = ''):string
  {
    return this.utilitariosService.TransformarFecha(value, incluirHora, formatoEspecifico);
  }
}